import fetch from 'unfetch'
import app from '@/app.js'
import { cartError, cartSuccess } from '@/lib/cartResponse.js'

const carDrawerFooter = document.querySelector('[data-cart-drawer-footer]')

export function addVariant(variant, quantity, callback) {
    return fetchCart().then(({ items }) => {
        return addItemById(variant.id, quantity, function () {
            callback()
        })
    })
}

export function updateAddon(id, quantity) {
    return fetchCart().then(({ items }) => {
        for (let i = 0; i < items.length; i++) {
            if (items[i].variant_id === parseInt(id)) {
                return changeAddon(i + 1, quantity) // shopify cart is a 1-based index
            }
        }
    })
}

export function removeAddon(id) {
    return updateAddon(id, 0)
}

function changeAddon(line, quantity) {
    app.emit('cart:updating')

    return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line, quantity }),
    })
        .then((res) => res.json())
        .then((cart) => {
            const { item_count } = cart
            if (item_count == 0) carDrawerFooter.classList.add('hidden')

            app.hydrate({ cart: cart })
            app.emit('cart:updated', { cart: cart })
            return cart
        })
}

export function addItemByForm(data, callback) {
    app.emit('cart:updating')

    return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
        },
        body: data,
    })
        .then((r) => r.json())
        .then((item) => {
            if (item.status) {
                cartError(item.description)
            } else {
                return fetchCart().then((cart) => {
                    carDrawerFooter.classList.remove('hidden')

                    app.hydrate({ cart: cart })
                    app.emit('cart:updated', { cart: cart })
                    app.emit('updated', { item, cart })
                    callback()
                    return { item, cart }
                })
            }
        })
}

export function addItemById(id, quantity, callback) {
    app.emit('cart:updating')

    return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id, quantity }),
    })
        .then((r) => r.json())
        .then((item) => {
            if (item.status) {
                cartError(item.description)
            } else {
                return fetchCart().then((cart) => {
                    carDrawerFooter.classList.remove('hidden')

                    app.hydrate({ cart: cart })
                    app.emit('cart:updated', { cart: cart })
                    app.emit('updated', { item, cart })
                    callback()
                    return { item, cart }
                })
            }
        })
}

export function submitUpsellProduct(id, quantity, callback, message, btn) {
    return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id, quantity }),
    })
        .then((r) => r.json())
        .then((item) => {
            if (item.status) {
                cartError(item.description)
            } else {
                return fetchCart().then((cart) => {
                    app.hydrate({ cart: cart })
                    app.emit('cart:updated', { cart: cart })
                    app.emit('upsell:added')
                    app.emit('updated', { item, cart })
                    callback()
                    return { item, cart }
                })
            }
        })
}

export function fetchCart() {
    return fetch('/cart.js', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then((res) => res.json())
}
